import React from 'react';

export function StatusPill({ status }) {
  const s = String(status || '').toUpperCase();
  const cls = {
    PENDING: 'bg-[hsl(43_74%_94%)] text-[hsl(43_74%_22%)] border-[hsl(43_60%_80%)]',
    APPROVED: 'bg-[hsl(152_45%_94%)] text-[hsl(152_45%_24%)] border-[hsl(152_35%_80%)]',
    REJECTED: 'bg-[hsl(0_72%_95%)] text-[hsl(0_72%_35%)] border-[hsl(0_60%_85%)]',
    IN_REVIEW: 'bg-[hsl(188_55%_94%)] text-[hsl(188_55%_26%)] border-[hsl(188_40%_82%)]',
    COMPLETED: 'bg-[hsl(152_45%_94%)] text-[hsl(152_45%_24%)] border-[hsl(152_35%_80%)]',
    NOT_STARTED: 'bg-[hsl(210_18%_94%)] text-[hsl(222_47%_11%)] border-[hsl(214_20%_88%)]',
    ACTIVE: 'bg-[hsl(152_45%_94%)] text-[hsl(152_45%_24%)] border-[hsl(152_35%_80%)]',
  }[s] || 'bg-[hsl(210_18%_94%)] text-[hsl(222_47%_11%)] border-[hsl(214_20%_88%)]';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.replaceAll('_', ' ')}
    </span>
  );
}
